import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import AddReport from './pages/AddReport';
import Personnel from './pages/Personnel';
import Approvals from './pages/Approvals';
import LabTeam from './pages/LabTeam';
import StationDistribution from './pages/StationDistribution';
import AccountSettings from './pages/AccountSettings';
import Pours from './pages/Pours';
import PoursFlowUp from './pages/pours/PoursFlowUp';
import Pour from './pages/Pour';
import PoursApproved from './pages/PoursApproved';
import TemperatureStations from './pages/pours/TemperatureStations';
import StationTemperature from './pages/pours/StationTemperature';
import Cubes from './pages/Cubes';
import CubesLog from './pages/cubes/CubesLog';
import TodaysBreaking from './pages/cubes/TodaysBreaking';
import UpcomingBreaking from './pages/cubes/UpcomingBreaking';
import TomorrowBreaking from './pages/cubes/TomorrowBreaking';
import NextWeekBreaking from './pages/cubes/NextWeekBreaking';
import BreakingResults from './pages/cubes/BreakingResults';
import BreakingResultsMain from './pages/cubes/BreakingResultsMain';
import AddBreakingResults from './pages/cubes/AddBreakingResults';
import ViewBreakingResults from './pages/cubes/ViewBreakingResults';
import Inventory from './pages/Inventory';
import StationInventory from './pages/StationInventory';
import AdminDeleteDashboard from './pages/AdminDeleteDashboard';
import InstallPrompt from './components/InstallPrompt';
import IOSInstallGuide from './components/iOSInstallGuide';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Toaster position="top-center" />
          <InstallPrompt />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/ios-install" element={<IOSInstallGuide />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-report"
              element={
                <ProtectedRoute>
                  <AddReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pours"
              element={
                <ProtectedRoute>
                  <Pours />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pours/flow-up"
              element={
                <ProtectedRoute>
                  <PoursFlowUp />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pours/pending"
              element={
                <ProtectedRoute>
                  <Pour />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pours/approved"
              element={
                <ProtectedRoute>
                  <PoursApproved />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pours/temperature"
              element={
                <ProtectedRoute>
                  <TemperatureStations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pours/temperature/:stationId"
              element={
                <ProtectedRoute>
                  <StationTemperature />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cubes"
              element={
                <ProtectedRoute>
                  <Cubes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cubes/log"
              element={
                <ProtectedRoute>
                  <CubesLog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cubes/todays-breaking"
              element={
                <ProtectedRoute>
                  <TodaysBreaking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cubes/upcoming"
              element={
                <ProtectedRoute>
                  <UpcomingBreaking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cubes/tomorrow-breaking"
              element={
                <ProtectedRoute>
                  <TomorrowBreaking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cubes/next-week"
              element={
                <ProtectedRoute>
                  <NextWeekBreaking />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cubes/results"
              element={
                <ProtectedRoute>
                  <BreakingResultsMain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cubes/results/add"
              element={
                <ProtectedRoute>
                  <AddBreakingResults />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cubes/results/view"
              element={
                <ProtectedRoute>
                  <ViewBreakingResults />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cubes/results/old"
              element={
                <ProtectedRoute>
                  <BreakingResults />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventory"
              element={
                <ProtectedRoute>
                  <Inventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventory/:station"
              element={
                <ProtectedRoute>
                  <StationInventory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/personnel"
              element={
                <ProtectedRoute>
                  <Personnel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/approvals"
              element={
                <ProtectedRoute>
                  <Approvals />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lab-team"
              element={
                <ProtectedRoute>
                  <LabTeam />
                </ProtectedRoute>
              }
            />
            <Route
              path="/station-distribution"
              element={
                <ProtectedRoute>
                  <StationDistribution />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account-settings"
              element={
                <ProtectedRoute>
                  <AccountSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/delete"
              element={
                <ProtectedRoute>
                  <AdminDeleteDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;